import { motion } from "framer-motion";
import { formatCurrency } from "./config";

const SolutionCard = ({ solution, solutionKey, values, onChange }) => {
  const Icon = solution.icon;
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm hover:shadow-lg transition-all duration-300 flex flex-col"
    >
      <div className="flex items-start gap-4 mb-4 min-h-[120px]">
        <div className="w-12 h-12 rounded-xl bg-[#0099CC]/10 flex items-center justify-center text-[#0099CC] flex-shrink-0">
          <Icon className="w-6 h-6" />
        </div>
        <div>
          <h3 className="text-lg font-bold text-[#0F172A] mb-2">{solution.title}</h3>
          <p className="text-sm text-slate-600 leading-relaxed">{solution.description}</p>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4 mt-auto">
        {['small', 'medium', 'large'].map((size) => (
          <div key={size} className="text-center flex flex-col">
            <label className="block text-xs font-medium text-slate-500 mb-1 uppercase tracking-wide">
              {size.charAt(0).toUpperCase() + size.slice(1)}
            </label>
            <p className="text-xs text-slate-400 mb-1 min-h-[32px] flex items-center justify-center">{solution.sizeDescriptions[size]}</p>
            <p className="text-xs text-[#0099CC] font-semibold mb-2 min-h-[28px] flex items-center justify-center">{solution.sizeLabels[size]}</p>
            <input
              type="number"
              min="0"
              value={values[size] || ''}
              onChange={(e) => {
                const val = Math.max(0, parseInt(e.target.value) || 0);
                onChange(solutionKey, size, val);
              }}
              placeholder="0"
              className="w-full px-3 py-3 text-center text-lg font-semibold bg-slate-50 border-2 border-slate-200 rounded-xl focus:border-[#0099CC] focus:ring-2 focus:ring-[#0099CC]/20 focus:outline-none transition-all"
              data-testid={`calc-${solutionKey}-${size}`}
            />
          </div>
        ))}
      </div>

      {/* Per-solution subtotal */}
      {(values.small > 0 || values.medium > 0 || values.large > 0) && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          className="mt-4 pt-4 border-t border-slate-100"
        >
          <div className="flex justify-between items-center text-sm mb-2">
            <span className="text-slate-500">Monthly potential:</span>
            <span className="font-bold text-[#0099CC]">
              {formatCurrency(
                (values.small || 0) * solution.payouts.small.monthly +
                (values.medium || 0) * solution.payouts.medium.monthly +
                (values.large || 0) * solution.payouts.large.monthly
              )}
            </span>
          </div>
          <div className="flex justify-between items-center text-sm">
            <span className="text-slate-500">Yearly potential:</span>
            <span className="font-bold text-[#0099CC]">
              {formatCurrency(
                (values.small || 0) * solution.payouts.small.year1 +
                (values.medium || 0) * solution.payouts.medium.year1 +
                (values.large || 0) * solution.payouts.large.year1
              )}
            </span>
          </div>
        </motion.div>
      )}
    </motion.div>
  );
};

export default SolutionCard;
